// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3eaS-","sendOtp":"AuthorizeToLogin_sendOtp__2l6n4"};